var axios = require("axios");

axios.interceptors.response.use(
    function (config) {
        return config;
    },
    function (err) {
        try {
            if (
                err.response.status === 401 &&
                err.response.data.error === "JWT Token Expirado"
            ) {
                localStorage.clear();
                const redirectUri = encodeURIComponent(window.location.pathname + window.location.search);
                window.location.href = `/entrar?redirect_uri=${redirectUri}`;
            }

            return Promise.reject(err);
        } catch (e) {
            console.log(e);
        }
    }
);
